<template>
	<VOverlay
		:title="$t('cd.newComposedDocument.title')"
		:size="2"
		:isVCentered="false"
		:closeOnBackgroundClick="true"
		:hasBackground="true"
		:modelValue="true"
		@update:modelValue="overlayClosed"
		:modalHasSharpCorner="true"
		@keydown.meta.s.prevent.stop="submit"
	>
		<VTitle classes="has-margin-bottom-0" :size="4" :text="$t('cd.newComposedDocument.whatName')" />

		<VInputString
			:isRequired="true"
			v-model:valueModel="docNameValue"
			:label="$t('cd.newComposedDocument.nameInputLabel')"
			:trim="true"
			@update:valueModel="markModified"
		/>

		<VTitle classes="has-margin-bottom-0" :size="4" :text="$t('cd.newComposedDocument.giveDescription')" />

		<VTextarea
			v-model="docDescription"
			:placeholder="$t('cd.newComposedDocument.giveDescription')"
			class="has-margin-bottom-4"
			:isNarrow="true"
		/>

		<VTitle classes="has-margin-bottom-0" :size="4" :text="$t('cd.newComposedDocument.whatConnection')" />

		<VField
			:label="$t('cd.newComposedDocument.selectConnection')"
			:isFloating="true"
			:class="{ 'is-active': connValue }"
		>
			<VSelect :options="connOptions" v-model="connValue" />
		</VField>

		<template #footer>
			<VButton
				:text="$t('cd.newComposedDocument.submitButton')"
				icon="chevron-right"
				:iconOnRight="true"
				classes="button-modal-footer"
				:isDisabled="!isValid"
				@clicked="submit"
			/>
		</template>
	</VOverlay>
</template>

<script>
import { mapGetters } from 'vuex';
import { getStoreAction, getStoreGetter, getStoreMutation } from '@assets/scripts/store/config';
import Helpers from '@assets/scripts/helpers';
import { useApiAsync } from '@assets/scripts/composables/useApi';

import {
	GET_CONNECTIONS,
} from '@assets/scripts/api/config';

export default {
	name: 'NewComposedDocument',
	data: function () {
		return {
			connOptions: [],
			connValue: false,
			docNameValue: '',
			docDescription: '',
		};
	},
	computed: {
		...mapGetters({
			currentConnection: getStoreGetter('CURRENT_CONNECTION', 'CD'),
			modified: getStoreGetter('MODIFIED', 'CD'),
		}),
		isValid: function () {
			return this.connValue && this.docNameValue.trim();
		},
	},
	mounted: async function () {
		// get all available connection
		const connections = await useApiAsync(GET_CONNECTIONS)

		// format connections to use in VSelect component
		if (connections.length > 0) {
			this.connOptions = Helpers.mapObjectArrayForSelect(connections, {
				key: 'conn_guid',
				text: 'name',
			});
		}

		if (this.currentConnection) this.connValue = this.currentConnection;
	},
	methods: {
		markModified: function () {
			// no need to trigger this mutation more than once
			if (this.modified) return;

			// mark composed document as modified whenever a
			// change is made
			this.$store.commit(
				getStoreMutation('MARK_MODIFIED', 'CD')
			);
		},
		overlayClosed: function () {
			this.$store.dispatch(
				getStoreAction('TOGGLE_CREATE_NEW', 'CD'),
				false
			);
		},
		submit: function () {
			if (!this.isValid) return;

			this.$store.dispatch(getStoreAction('NEW_COMPOSED_DOCUMENT', 'CD'), {
				name: this.docNameValue.trim(),
				description: this.docDescription.trim(),
				conn_guid: this.connValue,
			});
		},
	},
};
</script>
